// extracted by mini-css-extract-plugin
module.exports = {"mobilePageContainer":"styles_mobilePageContainer__p0Avt","mobilePageTitle":"styles_mobilePageTitle__7QZP8","mobilePageText":"styles_mobilePageText__lY6Ct"};